import { useDispatch, useSelector } from 'react-redux';
import { workQueueActions } from 'store/slices/workQueueSlice';

export const BULK_MODE = {
  FULFILLMENT: 'Fulfillment',
  TRANSFER_FACILITY: 'TransferFacility',
  CENTRAL_FILL: 'CentralFill',
};

export const useBulkQueueMode = () => {
  const dispatch = useDispatch();
  const bulkQueueMode = useSelector(({ workQueue }) => workQueue.bulkLabels.bulkMode);

  const setBulkQueueMode = (mode) => {
    dispatch(workQueueActions.updateBulkLabelsMode({ bulkMode: mode }));
  };

  const isTransferFacilityMode = bulkQueueMode === BULK_MODE.TRANSFER_FACILITY;
  const isCentralFillMode = bulkQueueMode === BULK_MODE.CENTRAL_FILL;

  return { bulkQueueMode, isTransferFacilityMode, isCentralFillMode, setBulkQueueMode };
};
